import { validationLength } from "../components/actions/validations";

const textMax = validationLength.roomFeatureName;

const spaceRule = (max: number) =>
  `Max ${max} characters; letters, numbers and spaces only; no special characters.`;

/** Default (non-error) helper text under Reserve Location fields. */
export const reserveLocationFieldHelperText = {
  area: `${spaceRule(textMax)} Mandatory.`,
  locationType: `${spaceRule(textMax)} Mandatory.`,
} as const;

/** Error helper text (shown in red when field validation fails). */
export const reserveLocationFieldErrors = {
  required: "This field is required.",
  area: spaceRule(textMax),
  locationType: spaceRule(textMax),
} as const;
